import { twMerge } from 'tailwind-merge';

interface BubbleMarkerProps {
  active: boolean;
  onClick: () => void;
}

export const BubbleMarker = (props: BubbleMarkerProps) => {
  const { active, onClick } = props;

  return (
    <div
      onClick={onClick}
      className={twMerge(
        'h-10 w-10 cursor-pointer rounded-[10px] bg-[#B6FAFF]',
        active ? `bg-[#ffffff]` : 'bg-[#ffffff]/10'
      )}
    />
  );
};
